<template>
    <base-box background-color="grey">
        <div slot="content">
            <g-media-object>
                <template slot="right">
                    <g-copy-button shape="circle" icon="copy" :minimalist="true" :copy-text="text" theme="live" />
                </template>
                <template>
                    <g-typography tag="span" font-weight="semibold" :value="label" />
                    <g-typography tag="span" :value="text" class="wrap-around" />
                </template>
            </g-media-object>
        </div>
    </base-box>
</template>

<script>
    export default {
        name:  'LinkCodeBox',
        props: {
            type: {
                type:     String,
                required: true,
            },
            text: {
                type:     String,
                required: true,
            },
        },
        computed: {
            label() {
                return `Your ${this.slug}: `;
            },
            slug() {
                return this.type
                    .toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .wrap-around {
        word-break: break-all;
    }
</style>
